export class Log {
  category: string;
  body: any;
  clientTraceId: string;

  constructor(category: string, body: any, clientTraceId: string) {
    this.category = category ?? '';
    this.body = body ?? '';
    this.clientTraceId = clientTraceId;
  }
}
